import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-initials-circle',
    templateUrl: './initials-circle.component.html',
    styleUrls: ['./initials-circle.component.scss'],
    standalone: false
})
export class InitialsCircleComponent implements OnInit {
    @Input() name: string;
    constructor() { }

    ngOnInit(): void { }
}
